import React, { MouseEvent, useState } from 'react';
import Icon from '@minecraft.icon';
import styled from 'styled-components';

export type StyledIconProps = {
  className?: string;
  onClick: () => void;
};

const StyledIcon = styled(Icon)<StyledIconProps>`
  cursor: pointer;
`;

const getArrowIconName = (isOpened, size) => (isOpened ? `chevron-open-${size}` : `chevron-closed-${size}`);

export type SizeType = 'thick' | 'thin';

export type UncontrolledArrowProps = {
  className?: string;
  isOpenedAsDefault?: boolean;
  onClick: (isOpened: boolean) => void;
  size?: SizeType;
};

export default ({ className, isOpenedAsDefault = false, onClick, size = 'thick' }: UncontrolledArrowProps) => {
  const [isOpened, setIsOpened] = useState(isOpenedAsDefault);

  return (
    <StyledIcon
      className={className}
      name={getArrowIconName(isOpened, size)}
      onClick={(event: MouseEvent<HTMLElement>): void => {
        const newIsOpened = !isOpened;

        onClick(newIsOpened);
        setIsOpened(newIsOpened);

        event.stopPropagation();
      }}
    />
  );
};
